import React from 'react';
import StatBadge from './StatBadge';
import SectionHeading from './SectionHeading';
import SectionHtml from './SectionHtml';
import SectionChart from './SectionChart';
import SectionCommentary from './SectionCommentary';
import SectionDataTable from './SectionDataTable';
import SectionRule from './SectionRule';
import ChartPlaceholder from '../../../../ChartContent/ChartPlaceHolder';
import SectionRelatedPosts from './SectionRelatedPosts';
import { useSelector } from 'react-redux';
import SectionPromo from './SectionPromo';

const ContentBlock = ({ contentBlock, dashboardId, paywallText }) => {
    const hasAccess = useSelector(state => state.reader?.has_access);
    const obscured = !hasAccess && contentBlock?.require_access_to_view;

    switch (contentBlock.type) {
        case 'stat_badge':
            return <StatBadge {...contentBlock} obscured={obscured} />;
        case 'heading':
            return <SectionHeading {...contentBlock} />;
        case 'rte':
            return <SectionHtml {...contentBlock} />;
        case 'chart':
            if (obscured) return <ChartPlaceholder paywallText={paywallText} />
            
            return (
                <SectionChart
                    {...contentBlock}
                    dashboardId={dashboardId}
                />
            );
        case 'commentary':
            return <SectionCommentary {...contentBlock} obscured={obscured} />;
        case 'data_table':
            return <SectionDataTable {...contentBlock} />;
        case 'rule':
            return <SectionRule />;
        case 'related_posts':
            return <SectionRelatedPosts {...contentBlock} />;
        case 'promo':
            if (hasAccess) return null; // Don't show promo if user has access
            
            return <SectionPromo {...contentBlock} />;
        default:
            return;
    }
};

export default ContentBlock;
